// extracted by mini-css-extract-plugin
export var divider = "_p3-0";
export var systemMessage = "_p3-1";
export var systemMessageWrapper = "_p3-2";